module.exports = __webpack_public_path__ + "static/media/GUIDE_0069_01.74d63dcb.jpg";